module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/pic2-9e99e723e24e43d6f551dabc05a3a06b.png";